module.exports = __webpack_public_path__ + "static/img/hook.f145be99.png";